import React from 'react';
import PropTypes from 'prop-types';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import ChangeTripReasonTypeSelect from '../../../../common/forms/select/ChangeTripReasonTypeSelect';
import ChangeTripReasonCategorySelect from '../../../../common/forms/select/ChangeTripReasonCategorySelect';
import CustomerSelectBusAssignmentChangerSelect from '../../../../common/forms/select/CustomerSelectBusAssignmentChanger';
import LocationSelect from '../../../../common/forms/select/LocationSelect';
import BusMaintenanceStaySelect from '../../../../common/forms/select/BusMaintenanceStaySelect';

const selector = formValueSelector('DeleteTripForm');

const DeleteTripForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  changeTripReasonCategoryValue,
  itineraryId
}) => (
    <>
      <Form onSubmit={handleSubmit(handleProcess)}>
        <p>Seguro de eliminar la programación del itinerario</p>
        <hr />
        <FormGroup row>
          <FormItem label="Departamento" required>
            <Field
              name="changeTripReasonCategory"
              component={ChangeTripReasonCategorySelect}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tipo" required>
            <Field
              name="changeTripReasonType"
              component={ChangeTripReasonTypeSelect}
              validate={[isRequired]}
              categoryId={
                changeTripReasonCategoryValue
                  ? changeTripReasonCategoryValue.value
                  : null
              }
              isDisabled={!changeTripReasonCategoryValue}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Responsable">
            <Field
              name="responsible"
              component={CustomerSelectBusAssignmentChangerSelect}
              placeholder="Responsable de la eliminación"
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Ubicación">
            <Field
              name="location"
              component={LocationSelect}
              placeholder="Ubicación donde se realiza la eliminación"
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Estancia de Mantenimiento">
            <Field
              name="busMaintenanceStay"
              component={BusMaintenanceStaySelect}
              itineraryId={itineraryId}
              placeholder="Estancia de mantenimiento relacionada a la eliminación"
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name="observation"
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
            />
          </FormItem>
        </FormGroup>
        <FormFooter
          saveButtonColor="danger"
          saveButtonIcon="fa fa-trash"
          saveButtonText="Eliminar"
        >
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );

DeleteTripForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  changeTripReasonCategoryValue: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  itineraryId: PropTypes.number.isRequired,
};

DeleteTripForm.defaultProps = {
  changeTripReasonCategoryValue: null,
};

const mapStateToProps = (state) => ({
  changeTripReasonCategoryValue: selector(state, 'changeTripReasonCategory'),
});

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'DeleteTripForm',
})(DeleteTripForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
